import React, {useCallback} from 'react';
import styled from 'styled-components';
import moment from 'moment';
// Styled component for slot button
const SlotButtonContainer = styled.button`
    padding: 0.3rem;
    border-radius: 0.5rem;
    transition: all 0.2s ease-in-out;
    position: relative;
    overflow: hidden;
    font-size: 0.75rem;
    width: 100%;
    flex-shrink: 0;

    /* Selected state */
    ${props =>
	props.$isSelected &&
	`
      border: 1px solid #9cc54b;
      background-color: #9cc54b;
      color: #ffffff;
      font-weight: bold;
  `}

        /* Available but not selected */
    ${props =>
	!props.$isSelected &&
	props.$isAvailable &&
	`
      border: 1px solid #9cc54b;
      background-color: #ffffff;
      color: #9cc54b;
      font-weight: normal;
  `}

        /* Unavailable state */
    ${props =>
	!props.$isAvailable &&
	`
      border: 1px solid #e9ecef;
      background-color: #e9ecef;
      color: #6c757d;
      cursor: not-allowed;
      font-weight: normal;
  `}

    &:hover:not(:disabled) {
        border-color: #9cc54b;
        box-shadow: 0 0 0 0.2rem rgba(156, 197, 75, 0.25);
    }
`;

const SlotButton = ({slot, onSlotSelected, selectedSlotId, externalCourier}) => {
	// Use available_capacity from slot for availability check
	let isAvailable = true;
	if (parseInt(slot.is_deleted) || parseInt(slot.slot_expired) || parseInt(slot.stop_accepting_orders)) {
		isAvailable = false;
	}
	// Selected if slot_id matches
	const isSelected = selectedSlotId === slot.slot_id;

	// Memoize click handler to avoid re-creating it every render
	const handleClick = useCallback(
		e => {
			e.preventDefault();
			e.stopPropagation();
			if (isAvailable && onSlotSelected) {
				onSlotSelected(slot.slot_id, slot);
			}
		},
		[isAvailable, onSlotSelected, slot]
	);

	return (
		<SlotButtonContainer
			onClick={handleClick}
			$isSelected={isSelected}
			$isAvailable={isAvailable}
			$slotType={slot.type}
			disabled={!isAvailable}
			aria-disabled={!isAvailable}
			aria-pressed={isSelected}
			type="button"
		>
			{externalCourier == false ? moment(slot.date).format("dddd, DD MMMM YYYY") : slot.label}
		</SlotButtonContainer>
	);
};

export default SlotButton;
